/**
 * @file caption-settings-menu-item.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _textTrackMenuItemJs = require('./text-track-menu-item.js');

var _textTrackMenuItemJs2 = _interopRequireDefault(_textTrackMenuItemJs);

var _componentJs = require('../../component.js');

var _componentJs2 = _interopRequireDefault(_componentJs);

/**
 * The menu item for caption track settings menu
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends TextTrackMenuItem
 * @class CaptionSettingsMenuItem
 */

var CaptionSettingsMenuItem = (function (_TextTrackMenuItem) {
  _inherits(CaptionSettingsMenuItem, _TextTrackMenuItem);

  function CaptionSettingsMenuItem(player, options) {
    _classCallCheck(this, CaptionSettingsMenuItem);

    options['track'] = {
      'kind': options['kind'],
      'player': player,
      'label': options['kind'] + ' settings',
      'selectable': false,
      'default': false,
      mode: 'disabled'
    };

    // CaptionSettingsMenuItem has no concept of 'selected'
    options['selectable'] = false;

    _TextTrackMenuItem.call(this, player, options);
    this.addClass('vjs-texttrack-settings');
    this.controlText(', opens ' + options['kind'] + ' settings dialog');
  }

  /**
   * Handle click on menu item
   *
   * @method handleClick
   */

  CaptionSettingsMenuItem.prototype.handleClick = function handleClick() {
    this.player().getChild('textTrackSettings').show();
    this.player().getChild('textTrackSettings').el_.focus();
  };

  return CaptionSettingsMenuItem;
})(_textTrackMenuItemJs2['default']);

_componentJs2['default'].registerComponent('CaptionSettingsMenuItem', CaptionSettingsMenuItem);
exports['default'] = CaptionSettingsMenuItem;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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